import styled from 'styled-components'
import { Spin as AntSpin } from 'antd'

export const ContainerSegmentControl = styled.div`
  margin-top: 12px;
  padding: 0 12px 12px 12px;
`

export const Spin = styled(AntSpin)`
  margin-top: 16px;
`
